import { authFetch } from "@/lib/auth";

export async function downloadDiscoveryPdf(reportId, filename = "brightiq-discovery-report.pdf", lang = null) {
  const res = await authFetch(`/api/discovery/reports/${reportId}/pdf${lang ? `?lang=${lang}` : ""}`);
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(typeof data.detail === "string" ? data.detail : "PDF download failed");
  }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
